<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 240px">
        <p style="width: 90px">对账单编号：</p>
        <el-input v-model="numIpt" size="mini" style="width:150px" placeholder="请输入对账单编号"/>
      </div>
      <div class="navContainer" style="width: 220px">
        <p style="width: 70px">标题：</p>
        <el-input v-model="titleIpt" size="mini" style="width:150px" placeholder="请输入标题"/>
      </div>
      <div class="navContainer" style="width: 250px">
        <p>付款公司类型：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width:150px" placeholder="请选择付款公司类型">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 250px">
        <p>付款公司名称：</p>
        <el-input v-model="entrustIpt" size="mini" style="width:150px" placeholder="请输入付款公司名称"/>
      </div>
      <div class="navContainer" style="width: 420px">
        <p style="width: 120px">对账单生成时间：</p>
        <el-date-picker v-model="timeIpt[0]" size="mini" style="width:150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="datetime" placeholder="开始日期"/>
        <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
        <el-date-picker v-model="timeIpt[1]" size="mini" style="width:150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="datetime" placeholder="结束日期"/>
      </div>
      <div class="navContainer" style="width: 220px">
        <p style="width: 70px">状态：</p>
        <el-select v-model="stateIpt" size="mini" filterable style="width:150px" placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"


        >
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="settNo" label="对账单编号" align="center"/>
          <el-table-column prop="title" label="标题" align="center"/>
          <el-table-column prop="entrust" label="付款公司类型" align="center"/>
          <el-table-column prop="companyNameOld" label="付款公司名称" align="center"/>
          <el-table-column prop="createTime" label="对账单生成时间" align="center"/>
          <el-table-column prop="amount" label="收取费用" align="center"/>
          <el-table-column prop="status" label="状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="345" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button v-if="!scope.row.status" size="mini" class="searchBtn" type="primary" @click="changeClick(scope.row.id)">核对对账单</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button v-if="!scope.row.status" size="mini" type="primary" @click="auditClick(scope.row.id)">提交审核</el-button>
                <el-button v-if="scope.row.status===1" size="mini" type="danger" @click="disableClick(scope.row.id)">取消审核</el-button>
                <el-button v-if="scope.row.status===3" size="mini" type="primary" @click="invoiceClick(scope.row.id)">寄送发票</el-button>
                <el-button v-if="!scope.row.status" size="mini" type="info" @click="deleteClick(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='600px' center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">付款公司类型：</span>
              <span>{{detailData.name}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">付款公司名称：</span>
              <span>{{detailData.name}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">标题：</span>
              <span>{{detailData.title}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">收取费用：</span>
              <span>{{detailData.amount}}元</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>已选择费用</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailTable" border>
              <el-table-column label="序号" align="center" type="index"/>
              <el-table-column prop="portName" label="港口名称" align="center"/>
              <el-table-column prop="workNumber" label="作业编号" align="center"/>
              <el-table-column prop="workType" label="作业类型" align="center"/>
              <el-table-column prop="workDate" label="作业时间" align="center"/>
              <el-table-column prop="workTotal" label="作业数量" align="center"/>
              <el-table-column prop="operationTotal" label="加油/搭电量" align="center"/>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作记录</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='1200px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">付款公司类型：</span>
              <span>{{companyData.name}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">付款公司名称：</span>
              <span>{{companyData.name}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">标题：</span>
              <span>{{companyData.title}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">收取费用：</span>
              <span>{{companyData.amount}}元</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">上传时间：</span>
              <span>{{companyData.createTime}}</span>
              <span style="text-decoration: underline;color: rgb(51, 136, 255);cursor: pointer;margin-left: 10px;">下载</span>
              <span style="text-decoration: underline;color: rgb(51, 136, 255);cursor: pointer;margin-left: 10px;">重新上传</span>
            </div>


          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>已选择费用</span>
            </div>
            <div class="operationTable" >
              <el-table
                :data="tableData1"
                :row-class-name="tableRowClassName"
                border
                script
              >
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column prop="portName" label="港口名称" align="center"/>
                <el-table-column prop="workNumber" label="作业编号" align="center"/>
                <el-table-column prop="workType" label="作业类型" align="center"/>
                <el-table-column prop="workDate" label="作业时间" align="center"/>
                <el-table-column prop="workTotal" label="作业数量" align="center" />
                <el-table-column prop="operationTotal" label="加油/搭电量" align="center"/>
                <el-table-column prop="remark" label="说明" align="center"/>
                <el-table-column label="操作" align="center" width="170">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;padding-left: 10px">
<!--                      <el-button size="mini" type="primary" @click="changePriceClick(scope.$index, scope.row)">修改金额</el-button>-->
                      <el-button size="mini" type="danger" @click="removeClick(scope.$index, 0)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>未选择费用</span>
            </div>
            <div class="operationTable" >
              <el-table
                :data="tableData3"
                :row-class-name="tableRowClassName"
                border
                script
              >
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column prop="portName" label="港口名称" align="center"/>
                <el-table-column prop="workNumber" label="作业编号" align="center"/>
                <el-table-column prop="workType" label="作业类型" align="center"/>
                <el-table-column prop="workDate" label="作业时间" align="center"/>
                <el-table-column prop="workTotal" label="作业数量" align="center" />
                <el-table-column prop="operationTotal" label="加油/搭电量" align="center"/>
                <el-table-column prop="remark" label="说明" align="center"/>
                <el-table-column label="操作" align="center" width="170">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;padding-left: 10px">
                      <el-button size="mini" type="primary" @click="addTableClick(scope.$index, 0)">添加</el-button>
                      <el-button size="mini" type="primary">首页提醒</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

        </div>
      </div>
    </el-dialog>

    <el-dialog title="填写发票寄送方式" :visible.sync="invoiceVisible" width='600px' @close="invoiceClose" center :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="invoiceData" label-width="110px" :rules="rules" ref="ruleForm" size="medium">
          <div-border label="开票选择" divStyle="margin-top: 10px">
            <el-form-item label="发票寄送方式：" prop="type" style="margin-top: 15px;">
              <el-radio v-model="invoiceData.type" :label="1">快递</el-radio>
              <el-radio v-model="invoiceData.type" :label="0">其它</el-radio>
            </el-form-item>
            <el-form-item v-if="invoiceData.type===1" label="快递类型：" prop="model">
              <el-input
                :style="'width:100%'"
                v-model="invoiceData.model"
                placeholder="请输入快递类型"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item v-if="invoiceData.type===1" label="快递单号：" prop="num">
              <el-input
                :style="'width:100%'"
                v-model="invoiceData.num"
                placeholder="请输入快递单号"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item label="寄送日期：" prop="date" style="margin-bottom: 20px;">
              <el-date-picker
                v-model="invoiceData.date"
                type="date"
                value-format="yyyy-MM-dd"
                size="mini"
                placeholder="选择寄送日期"/>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
              <el-input
                :style="'width:100%'"
                type="textarea"
                v-model="invoiceData.remark"
                placeholder="请输入备注"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确定</el-button>
            <el-button size="medium" class="resetBtn" @click="invoiceClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="提交审核" :visible.sync="auditVisible" width='600px' @close="auditClose" center :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="auditData" label-width="120px" :rules="rules2" ref="ruleForm2" size="medium">
          <div-border label="超出合同价" divStyle="margin-top: 10px;padding-top:15px;">
            <span style="color: #FF3A30;margin-left: 10px;">发现当前委托商有往期超出合同价未结算完！</span>
            <el-form-item label="是否抵扣超出合同价：" prop="deduction" label-width="160px">
              <el-radio v-model="auditData.deduction" :label="1">否</el-radio>
              <el-radio v-model="auditData.deduction" :label="0">是</el-radio>
            </el-form-item>
            <el-form-item v-if="auditData.deduction===0" label="最多可抵扣费用：" style="margin-bottom: 0">
              {{auditData.maxPrice}}元
            </el-form-item>
            <div class="departTable" v-if="auditData.deduction===0">
              <el-table border :data="auditData.table">
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column label="对账单编号" align="center">
                  <template slot-scope="scope">
                    <el-select v-model="auditData.table[scope.$index].num" size="mini" style="width:100%" filterable placeholder="请选择对账单" @change="numChange(scope.$index)">
                      <el-option v-for="item in numOption" :key="item.value" :label="item.label" :value="item.value"/>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="最大抵扣费用" align="center" prop="max"/>
                <el-table-column label="抵扣费用" align="center" prop="price">
                  <template slot-scope="scope">
                    <el-input v-model="auditData.table[scope.$index].price" size="mini" style="width:100%" placeholder="请输入抵扣费用"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center">
                    <img v-if="auditData.table.length!==1" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="numRemoveClick(scope.$index)"/>
                  </div>
                </el-table-column>
              </el-table>
              <div class="tableAddBtnContainer">
                <div class="AddContainer" @click="addCl">
                  <img alt="" :src="require('@/assets/images/u131.png')" />
                  <p>新增</p>
                </div>
              </div>
            </div>
          </div-border>
          <div-border label="开票选择" divStyle="margin-top: 10px;padding-top:15px;">
            <el-form-item label="开票总金额：" style="margin-bottom: 0">
              {{auditData.total}}元
            </el-form-item>
            <div style="display: flex;align-items: center;height: 50px;">
              <el-form-item label="是否暂缓开票：" style="margin-bottom: 5px;" prop="invoice">
                <el-radio v-model="auditData.invoice" :label="1">否</el-radio>
                <el-radio v-model="auditData.invoice" :label="0">是</el-radio>
              </el-form-item>
              <el-form-item v-if="!auditData.invoice" prop="invoicePrice" class="specialItem" style="margin-left: 10px;">
                <el-input type="number" v-if="!auditData.invoice" v-model="auditData.invoicePrice" size="mini" style="width:100%" placeholder="请输入暂缓开票金额">
                  <span slot="suffix" style="color: #999">|  元</span>
                </el-input>
              </el-form-item>
            </div>
            <el-form-item label="开票方式：" prop="type">
              <el-radio v-model="auditData.type" :label="1">自动</el-radio>
              <el-radio v-model="auditData.type" :label="0">手动</el-radio>
            </el-form-item>
            <el-form-item label="预计开票数量：" style="margin-bottom: 18px;">
              {{auditData.table2.length}}
            </el-form-item>
            <div class="departTable" style="padding-left: 20%">
              <el-table border :data="auditData.table2">
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column label="开票金额" align="center" prop="price">
                  <template slot-scope="scope">
                    <el-input :disabled="auditData.type===1" v-model="auditData.table2[scope.$index].price" size="mini" style="width:100%" placeholder="请输入开票金额"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center">
                    <img v-if="auditData.table2.length!==1 && auditData.type===0" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="invoiceRemoveClick(scope.$index)"/>
                  </div>
                </el-table-column>
              </el-table>
              <div class="tableAddBtnContainer" v-if="auditData.type!==1">
                <div class="AddContainer" @click="addCl2">
                  <img alt="" :src="require('@/assets/images/u131.png')" />
                  <p>新增</p>
                </div>
              </div>
            </div>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" @click="auditConfirmClick">确定</el-button>
            <el-button size="medium" class="resetBtn" @click="auditClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import steps from "@/components/steps";
import {formatDateTime} from "@/config/mUtils";
import divBorder from "@/components/divBorder";
import {
  accountDetail,
  accountList
} from "@/service/getData"

export default {
  components: {
    steps,
    divBorder,
  },
  data() {
    return {
      activeName:'first',
      entrustIpt:'',
      titleIpt:'',
      typeIpt:'',
      numIpt:'',
      stateIpt:'',
      timeIpt:['',''],
      stateOption:[
        {value:'',label:'全部',},
        {value:0,label:'待提交'},
        {value:1,label:'待审核'},
        {value:2,label:'未通过审核'},
        {value:3,label:'通过审核待开票'},
        {value:4,label:'开票失败'},
        {value:5,label:'开票成功待填写快递单号'},
      ],
      typeOption:[],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[
        // {id:111,show:false,entrust:'委托商1',tip:'重庆市xxxx',status:1,tableShow:false,child:[
        //     {id:222,state:1},
        //     {id:333,state:0},
        //   ]},
        // {id:444,show:false,entrust:'委托商1',status:0,tableShow:false,child:[]},
        // {id:555,show:true,entrust:'委托商1',status:2,tableShow:false,child:[]},
        // {id:666,show:true,entrust:'委托商1',status:3,tableShow:false,child:[]},
      ],
      detailDialogVisible:false,
      detailData:{},
      detailTable:[],
      operationData:[],
      dialogVisible:false,
      dialogTitle:'',
      addLoad:false,
      nameOption:[],
      payOption:[],
      addressOption:[],
      tableData1:[

      ],
      tableData3:[
        {waybill:'BH2011541',batch:'PC2011541',chassis:'DP2011541',brand:'品牌1',model:'型号',date1:'2021-10-30',date2:'2021-10-30',date3:'2021-10-30',start:'委托商1',end:'经销商1',type:'托运',rate:'1',price1:'60',price2:'70',remark:'相等'},
        {waybill:'BH2011541',batch:'PC2011541',chassis:'DP2011541',brand:'品牌1',model:'型号',date1:'2021-10-30',date2:'2021-10-30',date3:'2021-10-30',start:'委托商1',end:'经销商1',type:'托运',rate:'1',price1:'60',price2:'60',remark:'相等'},
      ],
      companyData:{},
      invoiceData:{},
      rules:{
        num:[
          { required: true, message: '请输入快递单号', trigger: 'blur' },
        ],
        date:[
          { required: true, message: '请选择寄送日期', trigger: 'change' },
        ],
        model:[
          { required: true, message: '请输入快递类型', trigger: 'blur' },
        ],
        type:[
          { required: true, message: '请选择发票寄送方式', trigger: 'change' },
        ],
      },

      selectedCar:[],




      allModel:[],
      expands:[],
      selectCostTable:[],
      costSize:0,
      costPage:0,
      invoiceVisible:false,
      auditVisible:false,
      auditData:{
        table2:[],
      },
      rules2:{
        deduction:[
          { required: true, message: '请选择是否抵扣超出合同价', trigger: 'change' },
        ],
        invoice:[
          { required: true, message: '请选择是否暂缓开票', trigger: 'change' },
        ],
        invoicePrice:[
          { required: true, message: '请输入暂缓开票金额', trigger: 'blur' },
        ],
        type:[
          { required: true, message: '请选择开票方式', trigger: 'change' },
        ],
        num:[
          { required: true, message: '请输入预计开票数量', trigger: 'blur' },
        ],
      },
      numOption:[
        {label:'D31835138135135',value:'1'},
        {label:'D31835138135135',value:'2'},
        {label:'D31835138135135',value:'3'},
        {label:'D31835138135135',value:'4'},
      ],
    };
  },
  computed:{
    stepState(){
      return function(state){
        switch(state) {
          case '':
            return 'wait'
          case 'success':
            return 'success'
          case 'failure':
            return 'error'
        }
      };
    },
    getState(){
      return function(state){
        switch(state) {
          case 0:
            return '待生效'
          case 1:
            return '生效中'
          case 2:
            return '已失效'
        }
      };
    },
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
  },
  mounted() {
    this._accountList()
  },
  methods: {
    async _accountList(){
      let obj={
        type:3,//委托商未知费用对账单
        settNo:this.numIpt,
        title:this.titleIpt,
        companyName:this.entrustIpt,
        createTime:this.timeIpt[0] ?this.timeIpt[0] :'',
        createTimeEnd:this.timeIpt[1] ?this.timeIpt[1]:'',
        status:this.stateIpt,
        page:this.page,
        rows:this.size,
      }
      this.tableLoad = true
      let res =await accountList(obj)
      this.tableLoad = false
      if (res.status !==0) return this.$message.error(res.methods)
      this.total = res.data.total
      this.TableDatas = res.data.records
    },
    compareDate(d1,d2) {
      return ((new Date(d1.replace(/-/g,"\/"))) > (new Date(d2.replace(/-/g,"\/"))));
    },
    // 结束时间
    dateChange(val) {
      if(this.timeIpt[1]&&this.timeIpt[0]&&this.compareDate(this.timeIpt[0],this.timeIpt[1])) {
        if(val == this.timeIpt[1]) this.timeIpt[1] = '';
        if(val == this.timeIpt[0]) this.timeIpt[0] = '';
        this.$forceUpdate();
        return this.$message.warning("结束日期必须大于开始日期！");
      }
    },
    //主页面条数
    contractSizeChange(sizes){
      this.size=sizes;
      this._accountList()
    },
    //主页面页数
    contractCurrentChange(page){
      this.page=page;
      this._accountList()
    },
    dialogClose(){
      this.dialogVisible=false;
      this.activeName='first';
    },
    bjDate(date, date1) {
      var date = new Date(date);
      var date1 = new Date(date1);
      // 减小于0 date<date1
      return date.getTime() - date1.getTime() < 0;
    },
    addClick(){
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.addLoad = true;
          this.addLoad = false;

          this.invoiceVisible=false;
        } else return false;
      });
    },
    nameChange(){},
    carClick(){
      this.carVisible=true;
      this.selectCar=[...this.selectedCar];
      this.brands=[...this.brands2];
      this.models=[...this.models2];
    },
    selectRemove(item){
      this.selectCar.splice(this.selectCar.indexOf(item),1)
      if(this.brands.indexOf(item)!==-1) this.brands.splice(this.brands.indexOf(item),1)
      else this.models.splice(this.models.indexOf(item),1)
    },

    tableRowClassName({row}) {
      if (row.price1!==row.price2) return 'ui-warning-row';
      else return '';
    },
    exportClick(){
      this.addVisible=true;
    },
    removeClick(index,val){

      this.tableData3.push(this.tableData1.splice(index, 1)[0])
    },
    addTableClick(index,val){
        this.tableData1.push(this.tableData3[index])
        this.tableData3.splice(index,1)
    },
    changePriceClick(val){},
    deleteClick(){
      this.$confirm('确认删除当前对账单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      }).catch(() => {});
    },
    hiddenClick(index,row){
      this.TableDatas[index].tableShow=!this.TableDatas[index].tableShow;
      Array.prototype.remove = function (val) {
        let index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      if (this.expands.indexOf(row.id) < 0) {
        this.expands.push(row.id);
      } else {
        this.expands.remove(row.id);
      }
    },
    disableClick(){
      this.$confirm('确认要取消审核申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      }).catch(() => {});
    },
    /**
     * 详情
     * @param id 表格id
     * @returns {Promise<ElMessageComponent>}
     */
    async detailClick(id){
      this.detailDialogVisible=true;
      let res = await accountDetail(id)
      if (res.status !==0) return this.$message.error(res.message)
      this.detailData = res.data
      this.detailTable = res.data.refuelingpowerInfos
      this.operationData = res.data.operateRecordList
    },
    invoiceClose(){
      this.invoiceVisible=false;
      this.$refs.ruleForm.resetFields();
    },
    invoiceClick(){
      this.invoiceVisible=true;
      this.invoiceData={
        type:1,
      };
    },
    async changeClick(id){
      this.dialogVisible=true;
      this.dialogTitle='核对对账单'
      let res = await accountDetail(id)
      if (res.status !==0) return this.$message.error(res.message)
      this.companyData = res.data
      this.tableData1 = res.data.refuelingpowerInfos
      // this.tableData3 = res.data.refuelingpowerInfos
    },
    searchBtn(){
      this.page = 1;
      this._accountList();
    },
    resetBtn(){
      this.entrustIpt='';
      this.titleIpt='';
      this.numIpt='';
      this.typeIpt='';
      this.stateIpt='';
      this.timeIpt=['',''];
    },
    auditClick(id){
      this.auditVisible=true;
      this.auditData={
        deduction:1,
        invoice:1,
        type:1,
        total:500,
        maxPrice:100,
        num:2,
        invoicePrice:0,
        table:[
          {num:'1231231231',max:12,price:10}
        ],
        table2:[
          {price:100},
          {price:200},
        ],
      }
    },
    auditClose(){
      this.auditVisible=false;
      this.$refs.ruleForm2.resetFields();
    },
    auditConfirmClick(){
      this.$refs.ruleForm2.validate(async valid => {
        if (valid) {
          if(this.auditData.deduction===0){
            if(this.auditData.table.length===0) return this.$message.warning('抵扣费用表格不能为空！')
            for(let i=0;i<this.auditData.table.length;i++){
              if(!this.auditData.table[i].num || !this.auditData.table[i].price) return this.$message.warning('表格数据未填写完整！')
            }
          }
          if(this.auditData.type===0){
            if(this.auditData.table2.length===0) return this.$message.warning('开票表格不能为空！')
            for(let i=0;i<this.auditData.table2.length;i++){
              if(!this.auditData.table2[i].price) return this.$message.warning('开票表格未填写完整！')
            }
          }
          let totalNum=0;
          let num=0;
          this.auditData.table2.forEach(item=>{totalNum+=Number(item.price)})
          if(this.auditData.invoice===0){
            num=Number(this.auditData.total)-Number(this.auditData.invoicePrice)-totalNum;
          }else num=Number(this.auditData.total)-totalNum;
          if(num<0) return this.$message.warning(`开票金额与暂缓开票金额之和不能大于开票总金额！`)
          this.auditVisible=false;
        } else return false;
      });
    },
    numChange(index){
      this.auditData.table[index].max=123;
      this.auditData.table[index].price=456;
    },
    addCl(){
      this.auditData.table.push({num:''})
    },
    addCl2(){
      this.auditData.table2.push({price:''})
    },
    numRemoveClick(index){
      this.auditData.table.splice(index,1)
    },
    invoiceRemoveClick(index){
      this.auditData.table2.splice(index,1)
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .navContainer p {
      display: inline-block;
      width: 100px;
      text-align: right;
    }
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table__expand-icon:after{
          content: '';
        }
        .el-table__expand-icon > i {
          display: none;
        }
        .el-table__expand-column {
          border-right: none;
        }
        body .el-table th.gutter {
          display: table-cell !important;
        }
        .el-badge__content{
          top: 4px !important;
          right: 1px !important;
        }
        .el-badge__content{
          background-color: #F56C6C !important;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .carContainer{
    width:100%;
    padding: 15px 40px 10px 20px;
    max-height:75vh;
    overflow:auto;
    &Title{
      display: flex;
      flex-direction: column;
      span{
        color: #101010;
        font-weight: 700;
        margin-bottom: 5px;
      }
      &Content{
        width:100%;
        padding-left: 15px;
        display: flex;
        flex-wrap: wrap;
        align-items:center;
        margin-bottom: 10px;
        &Item{
          height:25px;
          padding:0 5px;
          background-color: #a4adb3;
          color:#fff;
          display: flex;
          align-items:center;
          justify-content:space-between;
          margin-right: 10px;
          margin-bottom: 5px;
          i{
            color:#000;
            font-size: 17px;
            cursor: pointer;
          }
          p{
            cursor: pointer;
          }
        }
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .imgContainer{
            display:flex;
            align-items: center;
          }
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table .ui-warning-row {
          background-color: #fef0f0!important;
        }
        .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover>td{
          background-color: #fef0f0!important;
        }
        .el-table .ui-warning-row .cell{
          color: red;
        }
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
        &Nav{
          width:100%;
          display: flex;
          align-items: center;
          justify-content:flex-end;
          span{
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .reasonContainer{
    width:100%;
    padding: 20px 30px;
    ::v-deep{
      .el-textarea__inner{
        min-height: 100px!important;
      }
    }
    .reasonBtn{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content:flex-end;
    }
  }
  .addCost{
    display: flex;
    flex-direction: column;
    padding: 10px 40px 10px 10px;
    max-height:75vh;
    overflow: auto;
    &Nav{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    &Table{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table__expand-icon:after{
          content: '';
        }
        .el-table__expand-icon > i {
          display: none;
        }
        .el-table__expand-column {
          border-right: none;
        }
        body .el-table th.gutter {
          display: table-cell !important;
        }
        .el-table__header .el-table-column--selection .cell .el-checkbox:after{
          color: rgb(127, 127, 127);
          content: "全选";
          font-size:12px;
          font-weight: 700;
          //margin-left: 2px;
        }
        .el-table__header .el-table-column--selection .cell .el-checkbox{
          margin-left: 8px;
        }
        .el-checkbox{
          margin-left: 16px;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .depart{
    width:100%;
    padding: 10px 40px 10px 10px;
    max-height:75vh;
    overflow:auto;
    &Table{
      margin-bottom: 25px;
      width: 100%;
      .tableAddBtnContainer{
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;
        .AddContainer{
          display: flex;
          align-items: center;
          &:hover{
            cursor: pointer;
          }
        }
        img{
          object-fit: cover;
          margin-right: 5px;
        }
        p{
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .specialItem{
      ::v-deep {
        .el-form-item__content{
          margin-left: 0!important;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item{
        margin-bottom:13px;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }

  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
